import useVerificationMethodSelection from 'modules/EndToEndEncryption/hooks/useVerificationMethodSelection';

const VerificationMethodSelectionManager = () => {
  useVerificationMethodSelection();
  return null;
};

export default VerificationMethodSelectionManager;
